var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-header d-xl-block d-none"},[_c('ul',{staticClass:"nav navbar-nav"},[_c('li',{staticClass:"nav-item"},[_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('h2',{staticClass:"brand-text mb-0",class:{
            'text-white': _vm.skin === 'dark',
            'text-primary': _vm.skin !== 'dark',
          }},[_vm._v(" KombiKlimaParca ")])])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }